import React from 'react';
import { createRoot } from 'react-dom/client';
import './i18n/config';
import App from './App';

const container = document.getElementById('app');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}